// planetGenerator.js

var PlanetGenerator = pc.createScript('planetGenerator');

//overall usage setting
PlanetGenerator.attributes.add('standAlone', {type: 'boolean', title: 'standAlone'});
PlanetGenerator.attributes.add('planetType', { type: 'string', title: 'PlanetType'});
//planetary system randomization
PlanetGenerator.attributes.add('civProb', { type: 'number', title: 'CIV propability (1-10)'});
PlanetGenerator.attributes.add('civStellar', { type: 'number', title: 'CIV stellar (1-10)'});
PlanetGenerator.attributes.add('civInterStellar', { type: 'number', title: 'CIV Interstellar(1-10)'});
PlanetGenerator.attributes.add('civStation', { type: 'number', title: 'CIV SpaceStationProb(1-10)'});
PlanetGenerator.attributes.add('oceanProb', { type: 'number', title: 'Ocean propability (1-10)'});
PlanetGenerator.attributes.add('moonProb', { type: 'number', title: 'Moon propability (1-10)'}); //generating moon(s) as part of planetary system
PlanetGenerator.attributes.add('ringProb', { type: 'number', title: 'Ring propability (1-10)'});

PlanetGenerator.attributes.add('cubemap', {type:'asset', assetType:'cubemap'});

//flags for types of heavenly body
PlanetGenerator.attributes.add('moon', { type: 'boolean', title: 'Is this a Moon?'}); //if script is reused for generating moons
PlanetGenerator.attributes.add('moonEnt', { type: 'entity', title: 'Proto Moon'}); //moon entity for multiple instanciation
PlanetGenerator.attributes.add('maxMoons', { type: 'number', title: 'Maximum ammount of Moons'});
PlanetGenerator.attributes.add('moonMeshes', { type: 'asset', assetType: 'model', title: 'Moon Meshes', array: true}); //variation for moon sizes
PlanetGenerator.attributes.add('moonMeshesCapless', { type: 'asset', assetType: 'model', title: 'Moon Meshes Capless', array: true}); //variation for moon sizes


//mats and textures for random assignment

PlanetGenerator.attributes.add('matBase', { type: 'asset', array: true});
PlanetGenerator.attributes.add('matCaps', { type: 'asset', array: true});
PlanetGenerator.attributes.add('matBiome', { type: 'asset', array: true});
PlanetGenerator.attributes.add('matCiv', { type: 'asset', array: true});
PlanetGenerator.attributes.add('noiseMap', { type: 'asset', assetType: "texture", array: true});
PlanetGenerator.attributes.add('contMap', { type: 'asset', assetType: "texture", array: true});

PlanetGenerator.attributes.add('rings', { type: 'entity', array: true});



// initialize code called once per entity
PlanetGenerator.prototype.initialize = function() {
    
    this.seedScript = this.app.root.findByName('SEEDER').script.seeder;
    this.theSeed = 0.0;
    this.randomize = 0.0;
    this.kII = false;
    this.solarScript = this.app.root.children[0].script.solarSystem;
        
    this.ocean = null;
    this.civilization = null;
    this.interStellar = null;
    this.stellar = null;
    this.station = null;
    this.ringVisible = false;
    this.materialIndex = 0;
    this.startIt = false;
    this.app.keyboard.on(pc.EVENT_KEYDOWN, this.onKeyDown, this);
    this.app.keyboard.on(pc.EVENT_KEYUP, this.onKeyUp, this);
    this.checkStatusOnce = true;
    this.StartAssignOnce = true;
    this.isloaded = true;
    this.stationRandom = 0;
    this.satelliteSwitch = false;
    this.forceField = false;
    this.ringStations = false;
    this.planetIndex = 0;
    this.civFeats = new Array(0);
    
    //find according children - hierachy must not be changed
    this.mesh1 = this.entity.children[1]; //baseplanet
    this.mesh2 = this.entity.children[2]; //biome1
    this.mesh3 = this.entity.children[3]; //biome2
    this.mesh4 = this.entity.children[4]; //clouds
    this.mesh5 = this.entity.children[5]; //ocean
    this.mesh6 = this.entity.children[6]; //civilization
    
    if(!this.moon){
        this.mesh7 = this.entity.children[7].children[0]; //stellarFlights
        this.mesh8 = this.entity.children[7].children[1]; //interStellarFlights
        this.mesh9 = this.entity.children[7].children[2]; //station
        this.satellites = this.entity.children[7].children[3]; //satellites
        this.theForceField = this.entity.children[7].children[4]; // forcefield
        this.theRingStations = this.entity.children[7].children[5]; //ringstations
    }
    this.cont = null;
    
    // random variables
    this.randomRotBase = 0;
    this.randomRotBiome1 = 0;
    this.randomRotBiome2 = 0;
    this.randomRotClouds = 0 ;
    this.randomRotOcean = 0;
    this.moonRandom = 0;
    this.moonAmmountRandom = 0;
    this.moonData = new Array(0);
    this.mi1 = 0;
    this.mi2 = 0;
    this.mi3 = 0;
    this.mi4 = 0;
    this.ti1 = 0;
    this.ti2 = 0;
    this.civDmapOff = 0;
    this.civEmapOff = 0;
    this.ringRandom = 0;
    
    // for preloading exact textures:
    
    this.materialLoadCounter = 0;
    this.textureCounter = 0;
    this.base = null;
    this.bio1 = null;
    this.bio2 = null;
    this.caps = null;
    this.civ = null;
    this.texturePool = new Array(0);

};

PlanetGenerator.prototype.start = function(ind) {
   // console.log('nm: ' + this.entity.name + ' ind: ' + this.planetIndex);
    this.isloaded = true;
    this.StartAssignOnce = true;
    this.checkStatusOnce = true;
    this.texturePool = [];
    this.setRandoms();
};

PlanetGenerator.prototype.trigger = function() {
    
   
    
    this.mesh4.enabled = true;
    if(this.mesh4.children.length !== 0){
        for(var cld = 0; cld < this.mesh4.children.length; cld++){
            this.mesh4.children[cld].enabled = false;
        }
        this.mesh4.children[this.randomCloudMesh].enabled = true;
    }
    
        this.switchEntities();
        this.switchMat(this.mesh1); //switchmaterials: baseplanet
        this.switchMat(this.mesh2); //switchmaterials: biome1
        this.switchMat(this.mesh3); //switchmaterials: biome2
        this.mesh1.setLocalEulerAngles(0, this.randomRotBase, 0); //rotate baseplanet
        this.mesh2.setLocalEulerAngles(0, this.randomRotBiome1, 0); //rotate biome1
        this.mesh3.setLocalEulerAngles(0, this.randomRotBiome2, 0); //rotate biome2
        if (!this.moon) { //means this is a planet (moons get generated for this planet)/
            this.switchMat(this.mesh5); //switchmaterials: ocean
            this.switchMat(this.mesh6); //switchmaterials: cvilization
            
            this.mesh4.setLocalEulerAngles(0, this.randomRotClouds, 0); //rotate clouds
            this.mesh5.setLocalEulerAngles(0, this.randomRotOcean, 0); //rotate ocean
            if(this.ringVisible){
                this.rings[Math.floor(this.randomize() * this.rings.length)].enabled = true;
            }
            this.app.fire('planetLoaded:Planet');
            if (this.app.root.findByName('moonContainer')) {
                this.cont = this.app.root.findByName("moonContainer"); //if generation is retriggered - remove old moons
                this.cont.destroy(); //if generation is retriggered - remove old moons
            }
        }

};

PlanetGenerator.prototype.setRandoms = function () {
    
    //this.theSeed = this.seedScript.seed;
    this.randomize = new Math.seedrandom(this.theSeed);
    //console.log( 'name: ' + this.entity.name + 'seed: ' + this.theSeed + ' firstValue: ' + this.randomize());

    
    this.randomRotBase = Math.floor(this.randomize() * 360); // random rotation of baseplanet
    this.randomRotBiome1 = Math.floor(this.randomize() * 360); // '' biome1
    this.randomRotBiome2 = Math.floor(this.randomize() * 360); // '' biome2
    this.randomRotClouds = Math.floor(this.randomize() * 360); // '' clouds
    this.randomCloudMesh = Math.floor(this.randomize() * this.mesh4.children.length);
    this.randomRotOcean = Math.floor(this.randomize() * 360); // '' ocean
    this.moonRandom = Math.floor(this.randomize()*10); // propability of moons
    this.moonAmmountRandom = Math.floor(this.randomize() * this.maxMoons); // ammount of moons
    this.mi1 = Math.floor(this.randomize() * this.matBase.length); // mat base
    this.mi2 =Math.floor(this.randomize() * this.matBase.length); // mat caps
    this.mi3 = Math.floor(this.randomize() * this.matBase.length); // mat biome
    this.mi3_1 = Math.floor(this.randomize() * this.matBase.length);// mat biome2
    this.mi4 = Math.floor(this.randomize() * this.matCiv.length); // mat civilization
    this.ti1 = Math.floor(this.randomize() * this.noiseMap.length); // noise texture biome1
    this.ti2 = Math.floor(this.randomize() * this.noiseMap.length); // noise texture biome2
    this.civDmapOff = Math.floor(this.randomize() * 100); // offset civmap diffuse
    this.civEmapOff = Math.floor(this.randomize() * 100); // offset civmap emissive
    this.to = Math.floor(this.randomize() * this.contMap.length); // noise texture continents
    // propabilities defined in editor for ocean and possible degree of civilization - which is kinda useless now :P
    // this was before i considered a whole system generator 
    
    var oRd = Math.floor(this.randomize()*10);
    if(oRd >= this.oceanProb){
        this.ocean = false;
    } else {
        this.ocean = true;
    }
    
    var cRd = Math.floor(this.randomize()*10);
    if(cRd >= this.civProb){
        this.civilization = false;
        this.satelliteSwitch = false;
    } else {    
       // console.log('civTruePlanetGen');
        this.civilization = true;
        this.satelliteSwitch = true;
    }
    
    var isRd = Math.floor(this.randomize()*10);
    if(isRd >= this.civInterStellar){
        this.interStellar = false;
    } else {
        this.interStellar = true;
    }
        
    var sRd = Math.floor(this.randomize()*10);
    if(sRd >= this.civStellar){
        this.stellar = false;
    } else {                                   
        this.stellar = true;
    }
    
    if(this.solarScript.kIIevent){
        if(this.civilization){
            if(this.randomize() > 0.5){
                this.forceField = true;
            }
            if(this.randomize() > 0.35){
                this.ringStations = true;
            }
        }
    }

    var stRd = Math.floor(this.randomize()*10);
    this.stationRandom = stRd;
    if(stRd >= this.civStation){
        this.station = false;
    } else {
        this.station = true;
    }
    var rRd = Math.floor(this.randomize()*10);
    if(sRd >= this.ringProb){
        this.ringVisible = false;
    } else {                                   
        this.ringVisible = true;
    }


    this.base = this.matBase[this.mi1];
    this.bio1 = this.matBiome[this.mi3];
    this.bio2 = this.matBiome[this.mi3_1];
    this.caps = this.matCaps[this.mi2];
    this.civ = this.matCiv[this.mi4];
    
    this.checkStatus();
};

PlanetGenerator.prototype.loadMaterials = function(){
        
    var bs = this.app.assets.find(this.base.name);
    var bi1 = this.app.assets.find(this.bio1.name);
    var bi2 = this.app.assets.find(this.bio2.name);
    var cps = this.app.assets.find(this.caps.name);
    var civ = this.app.assets.find(this.civ.name);

    var that = this;
    
    this.app.assets.load(bs);
    this.app.assets.load(bi1);
    this.app.assets.load(bi2);
    this.app.assets.load(cps);
    this.app.assets.load(civ);
    


    bs.ready(function (bs) {
        that.materialLoadCounter += 1;
    });

    bi1.ready(function (bi1) {
        that.materialLoadCounter += 1;
    }); 
    
    bi2.ready(function (bi2) {
        that.materialLoadCounter += 1;
    });     
    
    cps.ready(function (cps) {
        that.materialLoadCounter += 1;
    });    
    
    civ.ready(function (civ) {
        that.materialLoadCounter += 1;
    });  
    
    this.checkTriggerCounter();

};

PlanetGenerator.prototype.checkTriggerCounter = function(){
    if(this.materialLoadCounter == 5){        
        this.startIt = true;
    }
};


PlanetGenerator.prototype.checkStatus = function() {

    var self = this;
    this.materialLoadCounter = 0;
    var tAssets = new Array(0);

    var aCount = 0;

    //materials base,bio1,bio2,caps & civ have beend picked out of a material array previously but not loaded yet

    this.texturePool.push(this.base.data.aoMap, this.base.data.diffuseMap, this.base.data.emissiveMap, this.base.data.normalMap,  this.base.data.heightMap);
    this.texturePool.push(this.bio1.data.aoMap, this.bio1.data.diffuseMap, this.bio1.data.emissiveMap, this.bio1.data.normalMap,  this.bio1.data.heightMap);
    this.texturePool.push(this.bio2.data.aoMap, this.bio2.data.diffuseMap, this.bio2.data.emissiveMap, this.bio2.data.normalMap,  this.bio2.data.heightMap);
    this.texturePool.push(this.caps.data.aoMap, this.caps.data.diffuseMap, this.caps.data.emissiveMap, this.caps.data.normalMap, this.caps.data.heightMap);
    this.texturePool.push(this.civ.data.diffuseMap);
    
    //not entirely sure why i did this loop in the first place - it cleanses the 'null' i get from empty texture slots
    //and gives back a type that i can actually 'load'
    
    this.texturePool.forEach(function(ca) {
        if(ca){
            if(ca.name !== undefined){
                var tTex = this.app.assets.find(ca.name, 'texture');
               // console.log(tTex);
                tAssets.push(tTex);
            }
        }
    });
                             
    this.texturePool.forEach(function(tp) {
        var tex = this.app.assets.get(tp);
       // console.info(tex);
        if (tex !== undefined && tex !== null) {
            if(tAssets.indexOf(tex) == -1){
                if(!tex.loaded){
                    tAssets.push(tex);
                }
            }
        } 
    });
    
    //this loop loads the textures by their id's that have been pushed from texturePool[] into tAssets[]  
    //with a callback to loadMaterials() which does what it is named after

    tAssets.forEach(function(ta) {
        
        if(!ta.loaded){
            this.app.assets.load(ta);
        }
        
        ta.ready(function() {
            aCount++;

            if (aCount == tAssets.length) {
                self.loadMaterials();
                self.texturePool = tAssets;
            }
        });  
    });

    //i only have a vague idea why i needed this though doesn't fire anymore.    

    if (tAssets.length === 0) {
        self.loadMaterials();
    }

};



PlanetGenerator.prototype.startAssign = function(){
    if(this.StartAssignOnce){
        this.StartAssignOnce = false;
        this.textureCounter = 0;
        this.texturePool = [];
        this.trigger();
    }
};



PlanetGenerator.prototype.setMoon = function(){
    if(this.moonRandom >= this.moonProb){
        var moonAmnt = this.moonAmmountRandom;
        var moonPos = 0;
        var myContainer = new pc.Entity();
        this.entity.addChild(this.cont);
        myContainer.name = "moonContainer";
        myContainer.setPosition(0,0,0);
        
        this.moonData.splice(0,this.moonData.length);
        
        for(i = 0; i <= moonAmnt; i++){
            var rnd = Math.floor(this.randomize() * this.moonMeshes.length);
            var posRnd = Math.floor(100 + this.randomize() * 100); 
            var rotRnd = Math.floor(this.randomize() * 360);
            var spdRnd = Math.floor(this.randomize()*10) + 1;
            spdRnd = spdRnd / 100;
            this.moonData.push('m',i, rnd, posRnd, rotRnd, spdRnd*100);
            moonPos += posRnd;
            var cln = this.moonEnt.clone();
            cln.children[0].setPosition(moonPos,0,0);
            cln.setLocalEulerAngles(0,rotRnd,0);
            cln.name = "spawnedMoon";
            cln.script.planetCloudRotator.speed = spdRnd;  
            var a = this.moonMeshes[rnd];
            var b = this.moonMeshesCapless[rnd];
            cln.children[0].children[1].model.model.asset = a.resource;
            this.cont.addChild(cln);
        }
    }
};

PlanetGenerator.prototype.switchMat = function(theMesh) {
    //console.log('pg ' + 'switchMat');
    //console.info(this.cubemap.resources.slice(1));
    //assign material & texture to variable

    var material = this.matBase[this.mi1];
    var materialCps = this.matCaps[this.mi2];
    var materialBio1 = this.matBiome[this.mi3]; //console.log('mi3: ' + this.mi3);
    var materialBio2 = this.matBiome[this.mi3_1]; //console.log('mi3_1: ' + this.mi3_1);
    var materialCiv = this.matCiv[this.mi4];
    var contTex = null;
    var fractTex1 = this.noiseMap[this.ti1].resource; //biome variation
    var fractTex2 = this.noiseMap[this.ti2].resource; //biome variation
    
    if(!this.moon){
        contTex = this.contMap[this.to].resource; //continent variation on OCEAN entity
    }
    var me = theMesh.model.meshInstances[0]; //assign mesh
    
    //link materials & textures and update materials:
    if(theMesh.name == "basePlanet"){
        var cps = theMesh.model.meshInstances[1];
        me.material = material.resource;    
        cps.material = materialCps.resource;
        cps.material.update();
    } else if(theMesh.name == "ocean") {
        //me.material.update();
        var m = me.material.clone();
        me.material = m;
        //m.cubeMap = this.cubemap;
        m.opacityMap = contTex;
        m.update();
        //console.info(m);

        if(this.mesh5.script.ScrollingNormal){
            this.mesh5.script.ScrollingNormal.material = m;
        }
        if(!this.ocean){this.mesh5.enabled = false;}
        if(this.ocean){this.mesh5.enabled = true;}
    } else if(theMesh.name == "cvilization") {
        me.material = materialCiv.resource;
        me.material.emissiveMapOffset.x = this.civEmapOff / 100;
        me.material.diffuseMapOffset.x = this.civDmapOff / 100;
        me.material.update();
        
        if(!this.civilization){this.mesh6.model.enabled = false;} else {this.mesh6.model.enabled = true;}
        
        if(!this.stellar){this.mesh7.enabled = false;} else {this.mesh7.enabled = true;}
        
        if(this.interStellar){this.mesh8.enabled = true;} else {this.mesh8.enabled = false;}

        // SPACESTATIONS
        if(!this.station){this.mesh9.enabled = false;} else {
            this.mesh9.enabled = true;
            for(var hd = 0; hd < this.stationRandom; hd++){
                this.mesh9.children[hd].enabled = false;
            }
            for(var sMp = 0; sMp < this.stationRandom; sMp++){
                var nc = this.mesh9.children[sMp];
                nc.enabled = true;
            }
            this.mesh9.setLocalEulerAngles(0,Math.floor(this.randomize()*360),0);
        }
        // SATELLITES
        this.satellites.enabled = this.satelliteSwitch;
        if(this.theForceField){
            if(this.forceField){
                this.theForceField.enabled = true;
            }
        }
        if(this.theRingStations){
            if(this.ringStations){
                this.theRingStations.enabled = true;
            }
        }
    } else {
        
        var b = null;

        if(theMesh.name == 'biome1'){
            me.material = materialBio1.resource;
            b = me.material.clone();
            me.material = b;
            b.opacityMap = fractTex1;
            b.name = 'clonedMat';
        }
        if(theMesh.name == 'biome2'){
            me.material = materialBio2.resource; 
            b = me.material.clone();
            me.material = b;
            b.opacityMap = fractTex2;
            b.name = 'clonedMat';
        }
        this.app.fire('planetGenerator:addMaterial', b);
        b.update();
    }
};

PlanetGenerator.prototype.switchEntities = function(){
    
};

// update code called every frame
PlanetGenerator.prototype.update = function(dt) {
    
    if (this.app.keyboard.wasReleased(pc.KEY_SPACE)) {
        if(this.standAlone){
            this.start();
        }
    }
    if(this.startIt){
        
        this.isloaded = false;
        this.startIt = false;
        this.startAssign();
    }
      
//     if (this.app.keyboard.wasPressed(pc.KEY_SPACE)) {
//         if (this.standAlone) {
//             this.setRandoms();
//         }
//     }
};

// swap method called for script hot-reloading
// inherit your script state here
// PlanetGenerator.prototype.swap = function(old) { };

// to learn more about script anatomy, please read:
// http://developer.playcanvas.com/en/user-manual/scripting/

